/**
 * Preloads the initial seed data.
 */
function preloadData() {
}

export default preloadData;
